/**
 * 更新用モジュール
 */
import { ThunkAction } from 'redux-thunk';

import { updateErrorSenetence } from '../services/contractApi';
// export { UpdateResult, DeleteResult } from '../services/contractApi';

export interface UpdateState {
  newCategories: number[];
  updateMessages: string[];
  statusU: number;
}

const initialState: UpdateState = {
  newCategories: [],
  updateMessages: [],
  statusU: 0,
};

const SET_UPDATE_CATEGORY = 'SET_UPDATE_CATEGORY';
type SET_UPDATE_CATEGORY = typeof SET_UPDATE_CATEGORY;

const SET_UPDATE_CATEGORIES = 'SET_UPDATE_CATEGORIES';
type SET_UPDATE_CATEGORIES = typeof SET_UPDATE_CATEGORIES;

const START_UPDATE = 'START_UPDATE';
type START_UPDATE = typeof START_UPDATE;

const FINISH_UPDATE = 'FINISH_UPDATE';
type FINISH_UPDATE = typeof FINISH_UPDATE;

const FAIL_UPDATE = 'FAIL_UPDATE';
type FAIL_UPDATE = typeof FAIL_UPDATE;

const CLEAR_UPDATE = 'CLEAR_UPDATE';
type CLEAR_UPDATE = typeof CLEAR_UPDATE;

interface SetUpdateCategory {
  type: SET_UPDATE_CATEGORY;
  index: number;
  category: number;
}

interface SetUpdateCategories {
  type: SET_UPDATE_CATEGORIES;
  categories: number[];
}

interface StartUpdate {
  type: START_UPDATE;
  index: number;
}

interface FinishUpdate {
  type: FINISH_UPDATE;
  index: number;
}

interface ClearUpdate {
  type: CLEAR_UPDATE;
}

interface FailUpdate {
  type: FAIL_UPDATE;
  index: number;
  updateMessages: string[];
  status: number;
}

export type UpdateAction = SetUpdateCategory | SetUpdateCategories |
  StartUpdate | FinishUpdate | FailUpdate | ClearUpdate;

type PostUpdate =
  ThunkAction<void, UpdateState, undefined, UpdateAction>;

export function startUpdate(index: number): StartUpdate {
  return {
    index,
    type: START_UPDATE,
  };
}

export function finishUpdate(index: number): FinishUpdate {
  return {
    index,
    type: FINISH_UPDATE,
  };
}

export function clearUpdate(): ClearUpdate {
  return {
    type: CLEAR_UPDATE,
  };
}

export function failUpdate(index: number, updateMessages: string[], status: number): FailUpdate {
  return {
    index,
    updateMessages,
    status,
    type: FAIL_UPDATE,
  };
}

export function setUpdateCategory(index: number, category: number): SetUpdateCategory {
  return {
    index,
    category,
    type: SET_UPDATE_CATEGORY,
  };
}

export function setUpdateCategories(categories: number[]): SetUpdateCategories {
  return {
    categories,
    type: SET_UPDATE_CATEGORIES,
  };
}

export function updateContent(
  index: number, id: string, newTagId: number, status: number): PostUpdate {
  return (dispatch) => {
    dispatch(startUpdate(index));
    return updateErrorSenetence(id, newTagId, status).then((res) => {
      const { status, result, messages, status_code } = res;
      if (status === 200 && result) {
        dispatch(finishUpdate(index));
      } else {
        dispatch(failUpdate(index, messages, status_code));
      }
    }).catch((err) => {
      dispatch(failUpdate(index, [String(err)], 500));
    });
  };
}

export default function reducer(
  state: UpdateState | undefined,
  action: UpdateAction,
): UpdateState {
  if (!state) return initialState;
  switch (action.type) {
    case SET_UPDATE_CATEGORY: {
      const newCategories = [...state.newCategories];
      newCategories[action.index] = action.category;
      return { ...state, newCategories };
    }
    case SET_UPDATE_CATEGORIES: {
      return { ...state, newCategories: action.categories, statusU: 200 };
    }
    case START_UPDATE: {
      return { ...state };
    }
    case FINISH_UPDATE: {
      return { ...state, updateMessages: [] };
    }
    case CLEAR_UPDATE: {
      return initialState;
    }
    case FAIL_UPDATE: {
      const { updateMessages, status } = action;
      return { ...state, updateMessages, statusU: status };
    }
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/modules/update.ts